import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ToastContext from "../../../../contexts/toast";
import { IMaskInput } from 'react-imask';
import { RichiestaService } from "../../../../services/RichiestaService";
import AlertMessage from "../../../Utility/Alert/AlertMessage";
import { FormUtility } from "../../../Utility/FormUtility";
import Input from "../../../Form/Input";
import InputIban from "../../../Form/InputIban";
import protocolloDsu from "../../../../assets/img/protocolloDsu.png"

const Step5 = (props) => {
  const richiesta = props.richiesta;
  const formRef = useRef(null);
  const previousBtnFunction = props.previousBtnFunction;
  const nextBtnFunction = props.nextBtnFunction;
  const [dirty, setDirty] = useState(false);
  const toastContext = useContext(ToastContext);
  const { id: richiestaId } = useParams();
  const [errorIban, setErrorIban] = useState(false);
  const [dsu, setDsu] = useState('');
  const [iban, setIban] = useState('');
  const [errorDsu, setErrorDsu] = useState(false);
  const afterSubmitFunction = props.afterSubmitFunction;
  const [showError, setShowError] = useState(false);
  const [inSave, setInSave] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);
  const [denominazioneBanca, setDenominazioneBanca] = useState(null);
  const [startUp, setStartup] = useState(true);

  const dsuInputRef = useRef(null);

  const richiestaService = new RichiestaService();

  const utility = new FormUtility();

  const onNextBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) nextBtnFunction();
  };

  const onPrevBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) previousBtnFunction();
  };

  useEffect(() => {
    if (dirty) {
      props.onChangedValue();
    }
  }, [dirty]);

  const handleDsuChange = (value, updateDirty = true) => {
    if (updateDirty && !startUp) {
      setDirty(true);
    }
    if (value?.length > 8) {
      value = value.substring(0, 8) + value.substring(8, 9).toUpperCase() + value.substring(9);
    }
    
    const isValid = validaDsu(value);
    setErrorDsu(!isValid);
    if(isValid)
      setDsu(value);
    else
      setDsu(null);
  };

  useEffect(() => {
    const data = richiesta.richiestaDatiPagamento;
    if (data?.iban) {
      setIban(data.iban);
      validazioneIBANItaliano({ target: { value: data.iban } }, false);
    }
    if (data?.dsu) {
      setDsu(data.dsu);
      handleDsuChange(data.dsu.substring(15), false); 
    }
    if(data?.denominazioneBanca) {
      setDenominazioneBanca(data.denominazioneBanca);
    }
    if(data?.iban != '' && data?.dsu != '')
      setDirty(false);

    setTimeout(() => {
      setStartup(false);
    }, 0);
  }, [richiesta]);

  function validaDsu(dsu) {
    setErrorDsu(false);
    const regex = /^\d{8}[A-Za-z]-\d{2}$/;
    const ok = regex.test(dsu);
    setErrorDsu(!ok);
    return ok;
  } 

  const saveAndnext = async () => {
    const isDsuOk = validaDsu(dsu);
    validazioneIBANItaliano({ target: { value: iban } }, false);
    if(errorDsu || errorIban || dsu === '' || iban === '' || !denominazioneBanca){
      setFormErrors();
      if(!isDsuOk)
        dsuInputRef.current.focus();
      //else
      setShowError(true);
      return;
    }
    if (dirty) 
      await save();
    onNextBtnClick(null);
  };

  const save = async () => {
    setInSave(true); // ⬅️ Start loading
    const dsuString = getINPS_ISEE_CurrentYear() + dsu;

    try {
      const result = await richiestaService.saveStep5(richiestaId,dsuString,iban,denominazioneBanca);

      richiesta.richiestaDatiPagamento = result.richiestaDatiPagamento;
      setDirty(false);
      if (afterSubmitFunction) afterSubmitFunction(result);
      toastContext.success("Dati salvati", 6000);
    } catch (err) {
      toastContext.error(utility.getErrorMsg(err), 2000);
      console.error(err);
    } finally {
      setInSave(false); // ⬅️ End loading
    }
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const validazioneIBANItaliano = (event, updateDirty = true) => {
    if (updateDirty) {
      setDirty(true);
    }
    setErrorIban(false);
    const ibanToCheck = event.target.value;
    let iban = event.target.value;
    iban = iban.replace(/\s/g, '').toUpperCase();
    const lunghezza = iban.length;
    const codicePaese = iban.substring(0, 2);

    if (codicePaese !== "IT") {
        setErrorIban(true);
        setIban(ibanToCheck);
        return false;
    }

    if (lunghezza !== 27) {
        setErrorIban(true);
        setIban(ibanToCheck);
        return false;
    }

    const cifreControllo = iban.substring(2, 4);
    const contoBase = iban.substring(4);
    let numeroRiorganizzato = contoBase + codicePaese + cifreControllo;
    numeroRiorganizzato = numeroRiorganizzato.replace(/[A-Z]/g, (lettera) => {
        return parseInt(lettera, 36);
    });

    let resto = numeroRiorganizzato;
    let blocco;
    while (resto.length > 2) {
        blocco = resto.substring(0, Math.min(9, resto.length));
        resto = parseInt(blocco, 10) % 97 + resto.substring(blocco.length);
    }
    const isValid = parseInt(resto, 10) % 97 === 1;
    setErrorIban(!isValid);

    setIban(ibanToCheck);

    return isValid;
  }

  const getINPS_ISEE_CurrentYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return `INPS-ISEE-${currentYear}-`;
  }

  const inpsIseeCurrentYear = getINPS_ISEE_CurrentYear();

  return (
    <div className=" rtds-my-12 ">
      <div className="rtds-mb-6 ">
        <h1 className="rtds-text-2xl rtds-font-bold">Dati ISEE e di pagamento</h1>
      </div>
      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className="rtds-font-bold rtds-no-underline"
              title="obbligatorio"
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id="hasValidationForm"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
        >
          <h2 className="rtds-text-xl rtds-font-bold">ISEE</h2>
          <p>
            Inserire di seguito il numero di protocollo della DSU (Dichiarazione
            Sostitutiva Unica) presentata a INPS per l’attestazione ISEE dello
            studente beneficiario o del nucleo famigliare a cui appartiene (dove trovare il <a
              href={protocolloDsu}
              className="rtds-action-link
                rtds-action-link--has-icon"
              target="_blank" rel="noopener noreferrer"
            >
               numero di protocollo DSU?
              <svg
                className="rtds-icon rtds-fill-current rtds-h-6 rtds-w-6"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--arrow-small-right`}
                />
              </svg>
            </a>
            ).
          </p>
          <div className="rtds-field-row">
            <div className="rtds-input-field rtds-gap-1 ">
            <label className="rtds-input-field__label" htmlFor="dsu">Numero di protocollo della DSU&nbsp;
            <abbr
                className='rtds-font-bold rtds-no-underline'
                title='obbligatorio'
              >
          *
        </abbr>
            </label>
            <div className={`rtds-input rtds-background-04 rtds-rounded-lg ${showError && errorDsu ? 'has-error' : ''}`}>
            <span className="rtds-px-3 rtds-content-center rtds-content-03 rtds-whitespace-nowrap" style={{height: 'var(--spacing-11)'}}>{inpsIseeCurrentYear}</span>
            <IMaskInput
              mask="00000000A-00"
              value={dsu}
              onComplete={handleDsuChange}
              definitions={{
                A: /[A-Za-z]/,
              }}
              overwrite
              id="dsu"
              className="rtds-text-sm rtds-input-placeholder rtds-pr-12"
              inputRef={dsuInputRef}
            />

          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
            aria-hidden='true'
            focusable='false'
            role='img'
            hidden={!showError || !errorDsu}
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
            />
          </svg>
            
            </div>
            <span hidden={!showError || !errorDsu} className="rtds-input-field__error">DSU non valido</span>
          </div>
          </div>
          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

          <h2 className="rtds-text-xl rtds-font-bold">Dati di pagamento</h2>
          <p>
            Indicare il codice IBAN del conto su cui si desidera ricevere il
            contributo che verrà assegnato se la domanda sarà ritenuta idonea.{" "}
          </p>

          <AlertMessage 
          iconName="mini--information-circle"
          title="Attenzione!"
          message="l’IBAN deve essere intestato, o cointestato, al soggetto richiedente che sta presentando la domanda di accesso alla misura Libri Gratis."
          >

          </AlertMessage>

          <div className={`rtds-field-row relative`} >
                <InputIban
                  label={"IBAN"}
                  id={"iban"}
                  classInput={"rtds-text-sm rtds-input-placeholder rtds-uppercase"}
                  type={"text"}
                  onChange={validazioneIBANItaliano}
                  value={iban}
                  required
                  maxLength={27}
                  minLength={27}
                  classDiv={`${!showError || !errorIban ? '' : 'has-error'}`}
                  errorIban={showError && errorIban}
                  errorMessage={"Iban non valido"}

                />
                  
                <Input
                  label={"Nome banca"}
                  id={"denominazione"}
                  inputErrors={inputErrors}
                  classInput={"rtds-text-sm rtds-input-placeholder"}
                  type={"text"}
                  onChange={(event) => {setDenominazioneBanca(event.target.value); setDirty(true);}}
                  value={denominazioneBanca || ""}
                  required={true}
                  maxLength={255}
                />
          </div>

          <span hidden={!showError || !errorIban} className="rtds-input-field__error">Iban non valido</span>

          <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center">
            <div className="rtds-form-actions">
              <div
                className="rtds-inline-flex rtds-gap-1"
                role="group"
                aria-label="Ruolo"
              >
                <button
                  onClick={onPrevBtnClick}
                  type="button"
                  className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                >
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6  group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>{" "}
                  Indietro
                </button>
                <button
                  type="button"
                  disabled={inSave}
                  aria-busy={inSave}
                  className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                  onClick={saveAndnext}
                >
                  Salva<span className="lg:sx-diplay-none"> e vai avanti</span>
                  {inSave ? (
                    <>
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
                      </svg>
                      <span className="rtds-sr-only">Caricamento...</span>
                    </>
                  ) : (
                    <>
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                        />
                      </svg>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step5;

